import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import { getLogisticsBudget } from '@/service/operate/budgetReport';
export default function useLogisticsBudget(params) {
  var logisticsBudget = ref({
    totalYjcgsl: 0,
    totalSjrksl: 0,
    logisticsBudgetList: []
  });
  // 查询时间范围内停机详情
  var getLogisticsBudgetAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getLogisticsBudget(params.value);
          case 2:
            data = _context.sent;
            if (data) {
              logisticsBudget.value = data;
            }
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getLogisticsBudgetAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  var logisticsBudgetTotal = computed(function () {
    return [{
      num: logisticsBudget.value.totalYjcgsl,
      desc: '预计采购数量/条'
    }, {
      num: logisticsBudget.value.totalSjrksl,
      desc: '实际入库数量/条'
    }];
  });
  var logisticsBudgetData = computed(function () {
    return {
      pieData: logisticsBudget.value.logisticsBudgetList.map(function (item) {
        return {
          name: item.departmentname,
          value: item.cgzje
        };
      }).filter(function (item) {
        return item.value;
      }),
      unit: '元',
      customTooltip: true,
      tooltipFormatter: function tooltipFormatter(params) {
        return "\n          <div >\n            <div class=\"flex align-start\">\n              <span class=\"mt-1 mr-1\">".concat(params.marker, "</span>\n              <div>\n                <span style=\"font-size: 12px;\">").concat(params.name, "</span>\n                <div>\n                 <span style=\"font-size: 12px;\">").concat(params.value, "\u5143</span>\n                </div>\n              </div>\n            </div>\n          </div>\n          ");
      }
    };
  });
  return [logisticsBudgetTotal, logisticsBudgetData, getLogisticsBudgetAsync];
}